import current from './current';

const notice = [
  {
    path: '/notice/current',
    component: () => import('@/page/notice/Current.vue'),
    children: [...current],
    meta: {
      name: '공지사항',
      isMenu: false,
      isActive: false,
      isBread: true,
    },
  },
];

export default notice;
